import React from "react";
import ActionButtons from "./ActionButtons";
import ActionStepper from "./ActionStepper";
import "./actionBar.scss";
import { Divider } from "antd";

interface ActionBarProps {
  // isRoundFinished: boolean;
  // currentSessionQuestionAnswers: QuestionAnswers[];
  // currentSessionQuestions: Question[];
  // activeQuestionIndex: number;
  // handleQuestionClick: (questionIndex: number) => void;
}

const ActionBar: React.FC<ActionBarProps> = () => {
  return (
    <div className="action-bar-container" style={{ maxWidth: "1400px", margin: "0 auto" }}>
      <ActionButtons/>
      <Divider style={{ margin: "0px" }} />
      <ActionStepper/>
    </div>
  );
};

export default ActionBar;
